import { JsonObject, JsonProperty } from 'json2typescript';

import { TenantAttr } from '../attr/tenant-attr';

/**
 * èä½ä¿¡æ¯
 */
@JsonObject
export class Position {
  /**
   * è´¦å·Id
   */
  @JsonProperty('accountId', Number)
  accountId: number = undefined;

  /**
   * æå±å»é¢åç±»éç½®çç¸å³ä¿¡æ¯
   */
  @JsonProperty('attrs', [TenantAttr])
  attrs: TenantAttr[] = undefined;

  /**
   * æå±ç§å®¤
   */
  @JsonProperty('deptId', Number)
  deptId: number = undefined;

  /**
   * æå±ç§å®¤åç§°
   */
  @JsonProperty('deptName', String)
  deptName: string = undefined;

  /**
   * èä½ä¿¡æ¯çId
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * å·¥å·
   * ä¾: HC001
   */
  @JsonProperty('jobCode', String)
  jobCode: string = undefined;

  /**
   * æå±å»é¢Id
   */
  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  /**
   * æå±å»é¢åç§°
   */
  @JsonProperty('tenantName', String)
  tenantName: string = undefined;

  /**
   * ç¨æ·Id
   */
  @JsonProperty('userId', Number)
  userId: number = undefined;

  /**
   * ç¨æ·Id
   */
  @JsonProperty('admin', Boolean)
  admin: boolean = undefined;
}
